<template>
    <label
        class="checkbox"
        :class="[
            { 'is-disabled': isDisabled },
            { 'is-checked': isChecked }
        ]"
        :id="id"
        :fieldVal="fieldVal">
        <span
            class="checkbox-input check-icon"
            :class="{
                'is-disabled': isDisabled,
                'is-checked': isChecked
            }">
            <input
                class="checkbox-original"
                type="checkbox"
                :name="name"
                :disabled="isDisabled"
                :value="label"
                v-model="model"
                :id="id"
            />
        </span>
        <span
            class="checkbox-label"
            v-if="label">
            {{ label }}
        </span>
    </label>
</template>

<script>
    export default {
        name: 'Check',
        props: {
            value: {},
            label: {},
            indeterminate: Boolean,
            disabled: Boolean,
            checked: Boolean,
            name: String,
            trueLabel: [String, Number],
            falseLabel: [String, Number],
            id: String,
            controls: String,
            border: Boolean,
            size: String,
            fieldVal: Array,
            checkedVal:Array
        },
        data() {
            return {
                selfModel: false,
                focus: false,
                isLimitExceeded: false
            };
        },
        computed: {
            model: {
                get() {
                    return this.value !== undefined ? this.value : this.selfModel;
                },

                set(val) {
                    if (val){
                        if (this.fieldVal.length >= 4){
                            this.$toast('感兴趣的领域最多只能选择四个');
                            return;
                        }

                        this.selfModel = val;
                    }else {
                        this.selfModel = '';
                    }

                    this.$emit('input', {
                        val:val,
                        id: this.id
                    });
                }
            },
            isChecked() {
                if ({}.toString.call(this.model) === '[object Boolean]') {
                    return this.model;
                } else if (Array.isArray(this.model)) {
                    return this.model.indexOf(this.label) > -1;
                }

                return undefined;
            },
            isDisabled() {
                return this.disabled;
            },
        },
        created(){
            for(let index = 0;index < this.checkedVal.length;index++){
                if(this.id == this.checkedVal[index].id){
                    this.model = true;
                    break;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .checkbox {
        display: flex;
        align-items: center;

        .checkbox-input {
            position: relative;

            .checkbox-original {
                position: absolute;
                width: 0;
                height: 0;
                margin: 0;
                outline: 0;
                opacity: 0;
                z-index: 0;
            }
        }

        .check-icon:before  {
            font-family: "iconfont" !important;
            font-size: 30px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            content: "\e896";
            color: #E5E5E5;
        }

        &.is-checked {
            .check-icon,
            .check-label {
                color: #333;
            }
            .check-icon:before  {
                color: #037BFF;
                content: "\e895";
            }

        }
        &.is-disabled {
            .check-icon,
            .check-label {
                color: #c5cad5;
            }
        }
    }
    .checkbox-icon {
        position: relative;
    }
    .checkbox-label {
        padding-left: 10px;
        font-size: 22px;
        font-weight: 400;
        color: #333;
    }
</style>